import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="datepicker"
export default class extends Controller {
  static values = {
    minDate: String,
    maxDate: String
  }

  connect() {
    this.fp = flatpickr(this.element, {
      minDate: this.minDateValue || "today",
      maxDate: this.maxDateValue || null,
      dateFormat: "Y-m-d",
      allowInput: true,
      onOpen: (selectedDates, dateStr, instance) => {
        // Optional: add more logic here if needed
      }
    })
  }

  disconnect() {
    if (this.fp) {
      this.fp.destroy()
    }
  }
}
